import z from 'zod';

export const postSaveAndValidateRequestSchema = z.object({}).nullish();
